//
/* eslint max-statements: 0 */
/* eslint-disable max-len */
import React, { Component } from 'react';
import classnames from 'classnames';
import styles from './style.module.css';
import { Container } from '../../components/Container/index';
import { Button as ButtonComponent } from '../../components/Button/index';
import { BrandLogo } from '../../components/BrandLogo';

import svg from './UnlockGrey.svg';
import { queryString } from '../../utilities/queryString';
import _forEach from 'lodash/forEach';
import { getLocalString } from '../../languages/index';
import { PrivacyLink } from '../../components/PrivacyLink';
import { useLocation } from 'react-router-dom';


class MobileAccessPageProxy extends Component {

  state = {
    orgId: '',
    loginId: ''
  };

  componentDidMount () {
    const queryStringParsed = queryString.parse(this.props.location?.search || '');
    const updater = {};
    _forEach(['orgId', 'loginId', 'env'], (x) => {
      updater[x] = queryStringParsed[x];
    });
    this.setState(updater);
  }

  handleSubmit = () => {
    window.location.href = '/?org='+ this.state.orgId +
      '&loginId=' + encodeURIComponent(this.state.loginId)+'&env='+this.state.env;
    // localStorage.remove('REDIRECT_TO_AFTER_SESSION_DESTROY');
  };

  render () {
    return (
      <Container className={styles.container}>
        <div className={classnames(styles.content, 'row')}>
          <BrandLogo
            style={{
              marginBottom: '2rem'
            }}
          />
          <div className={classnames(styles.card, 'col-md-4')}>
            <p className={styles.cardTitle}>
              {getLocalString('Mobile_Access_Header')}</p>
            <div className={styles.borderTextBottomWrapper}>
              <div className={styles.borderTextBottom}/>
            </div>
            <div className={styles.SecQuesDescription}>
              <p>{getLocalString('Mobile_Access_Desc')}</p>
            </div>
            <div style={{ 'padding': '1rem 7rem' }}>
              <img src={svg} alt='MobileUnlockGreyImage'/>
            </div>
            <div className={styles.topBuffer}>
              <ButtonComponent
                type={'primary'}
                style={{
                  width: '100%'
                }}
                onClick={this.handleSubmit}
              >
                {getLocalString('Continue_To_Login_Screen')}
              </ButtonComponent>
            </div>
          </div>
          {PrivacyLink()}
        </div>
      </Container>
    );
  }
}

// Wrapper component to provide React Router v6 location data to the class component
const MobileAccessPageWithLocation = (props) => {
  const location = useLocation();
  return <MobileAccessPageProxy {...props} location={location} />;
};

export const MobileAccessPage = MobileAccessPageWithLocation;